//TODO:  this is a quick and dirty address formatting pipe.

//TODO: move AddressType to a common library??

//TODO: support other options   (condensed, single line, multi line, etc.)

import { Injectable, Pipe, PipeTransform } from '@angular/core';

export class AddressType {
    Address_Line_1: string;
    Address_Line_2: string;
    Address_Line_3: string;
    City: string;
    State: { Value: string; Desc: string };
    Zip: string;
    County: string;
    Country: string;
}

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'epAddress',
    standalone: false
})
export class AddressPipe implements PipeTransform {
    transform(address: AddressType) {
        if (!address) {
            return '';
        }

        //console.log('address:' + JSON.stringify(address))

        let formatted = '';
        let delim = '';

        if (!!address.Address_Line_1) {
            formatted = formatted + address.Address_Line_1;
            delim = ', ';
        }
        if (!!address.Address_Line_2) {
            formatted = formatted + delim + address.Address_Line_2;
            delim = ', ';
        }
        if (!!address.Address_Line_3) {
            formatted = formatted + delim + address.Address_Line_3;
            delim = ', ';
        }
        if (!!address.City) {
            formatted = formatted + delim + address.City;
        }
        if (!!(address.State && address.State.Value)) {
            formatted = formatted + (!!address.City ? '  ' : ', ') + address.State.Value;
        }
        if (!!address.Zip) {
            formatted = formatted + ' ' + address.Zip;
        }

        return formatted.trim(); //+  " (raw=" + value + ")";
    }
}
